<template>
  <div></div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style>
</style>
